module.exports = __webpack_public_path__ + "static/img/触摸查询系统.40b5a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/触摸查询系统.png
// module id = oWqU
// module chunks = 45